import { compose, get, getOr } from 'lodash/fp';
import { createSelector } from 'reselect';
import { DateTimeService } from '@mews/framework';
import { getCurrentEnterpriseAppDateTimeNow } from '@mews-commander/legacy-entities/src/selectors/session/dateTime';
import { getSelectedServiceTimeUnit } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import { moduleSelector } from '../module';

const OCCUPANCY_POLLER_INTERVAL = 6;

export const getOccupancyStatistics = compose(get('occupancyStatistics'), moduleSelector);
export const isLoaded = compose(get('isLoaded'), getOccupancyStatistics);
export const getLastModified = compose(getOr(0, 'lastModified'), getOccupancyStatistics);

export const getOccupancyPollerStart = createSelector(
    getSelectedServiceTimeUnit,
    getCurrentEnterpriseAppDateTimeNow,
    // @ts-expect-error $TSFixMeError: Argument of type 'undefined' is not assignable to parameter of type 'DateTimeUnit'.
    (timeUnit, now) => DateTimeService.startOf(timeUnit)(now)
);

export const getOccupancyPollerEnd = createSelector(
    getOccupancyPollerStart,
    getSelectedServiceTimeUnit,
    // @ts-expect-error $TSFixMeError: Argument of type 'undefined' is not assignable to parameter of type 'DateTimePart'.
    (start, timeUnit) => DateTimeService.add(timeUnit)(start, OCCUPANCY_POLLER_INTERVAL)
);
